/**
 * @description
 *
 * Base class for defining custom errors. The purpose is to allow inherited custom errors to pass additional data to our ErrorBoundary's sentry logging when throwing the error (getContext).
 */
export class BaseCustomError extends Error {
  constructor(message) {
    var _Error$captureStackTr;
    super(message);
    this.name = this.constructor.name;

    // @ts-expect-error For proper stack trace
    (_Error$captureStackTr = Error.captureStackTrace) === null || _Error$captureStackTr === void 0 || _Error$captureStackTr.call(Error, this, this.constructor);
  }
}
export class CustomError extends BaseCustomError {
  constructor(message, context) {
    super(message);
    this.context = context;
    this.context = context;
    this.cause || (this.cause = (context === null || context === void 0 ? void 0 : context.error) || (context === null || context === void 0 ? void 0 : context.cause));
  }
  getContext() {
    return this.context;
  }
}
export class OfferIdNotFoundError extends BaseCustomError {
  constructor(message, context) {
    super(message);
    this.context = context;
    this.name = 'OfferIdNotFoundError';
    this.context = context;
    this.cause || (this.cause = (context === null || context === void 0 ? void 0 : context.error) || (context === null || context === void 0 ? void 0 : context.cause));
  }
  getContext() {
    return this.context;
  }
}
export function isCustomError(error) {
  return error instanceof Error && 'getContext' in error && typeof error.getContext === 'function';
}
export function getContextFromCustomError(error) {
  if (isCustomError(error)) {
    const context = error.getContext();
    if (typeof context === 'object' && context !== null && !Array.isArray(context)) {
      const fingerprint = 'fingerprint' in context && typeof context.fingerprint === 'string' ? context.fingerprint : undefined;
      return {
        context: Object.assign({}, context),
        fingerprint
      };
    }
  }
  return {
    context: {},
    fingerprint: undefined
  };
}